import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import useSelector from 'hooks/useSelector';

import { pending } from "./UserApprovalsPageSelector";

import {
    ChevronRight as RightIcon
} from '@mui/icons-material';

import { ReactComponent as UserApprovalsIcon } from "assets/icons/check-verified.svg";
import './UserApprovals.css';
import { ISelectOption } from '../forms/util';

interface UserApprovalsSidebarProps {
    selectedPage: ISelectOption
}

export const UserApprovalsSidebar = (props: UserApprovalsSidebarProps) => {
    const [currentSelection, setCurrentSelection] = useState(props.selectedPage);
    const profile = useSelector(state => state.profile);

    useEffect(() => {
        if (currentSelection === undefined) {
            setCurrentSelection(pending);
        }
    }, [profile]);

    return (
        <>
            <div className="ua-sidebar ua-sidebar-nav">
                <div className="ua-sidebar-title">
                    <UserApprovalsIcon />
                    <div className="d-inline-block">User Approvals</div>
                </div>

                <div className="ua-sidebar-item">
                    <Link
                        to={pending.getRoute().path as string}
                        className={`${ currentSelection == pending ? 'ua-nav-selected' : '' }`}>
                        <div className="row">
                            <div className="col-11">{pending.label}</div>
                            <div className="col-1"><RightIcon /></div>
                        </div>
                    </Link>
                </div>
            </div>
        </>
    );
};
